import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'helpMethod'

const OPTIONS = [
  {
    value: 'Replace a specific item',
    translationKey: 'pages.onboarding.helpMethod.options.replace',
    subtextKey: 'pages.onboarding.helpMethod.subtexts.replace',
    emoji: '🔄',
  },
  {
    value: 'Full-room inspiration',
    translationKey: 'pages.onboarding.helpMethod.options.fullRoom',
    subtextKey: 'pages.onboarding.helpMethod.subtexts.fullRoom',
    emoji: '✨',
  },
  {
    value: 'Surprise me',
    translationKey: 'pages.onboarding.helpMethod.options.surprise',
    subtextKey: 'pages.onboarding.helpMethod.subtexts.surprise',
    emoji: '🎁',
  },
]

export default function HelpMethodPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    // Find the selected option to get both value and subtext
    const selectedOption = OPTIONS.find((option) => option.value === value)
    const subtext = selectedOption ? t(selectedOption.subtextKey) : ''

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How do you want us to help you?',
      answer_key: value,
      answer: `${value} - ${subtext}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.helpMethod.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
